import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import AutoComplete from 'react-toolbox/lib/autocomplete';
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import Button from 'components/CustomButton';
import Error from 'components/ErrorMessage';
import { divisions, states } from 'constants/DropdownsValues';
import validateData from '../../../../../../common/utils/validations';
import styles from './AddCollege.scss';
import { theme } from './theme.css';
// to import local scss fle

class AddCollege extends Component {
  static propTypes = {
    addCollegeToDB: PropTypes.func.isRequired,
    collegeAdded: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      addAnotherCollege: false,
      showButton: false,
      hbcu: 'no',
      division: 'D1',
    };
  }


  getDataForCoach = (value) => {
    const newState = {
      city: value.city,
      division: value.division,
      questionLink: value.questionLink,
      state: value.state,
      teamPageUrl: value.teamPageUrl,
      college: value.value,
      collegeId: value.id,
      minAct: value.minAct,
      minGpa: value.minGpa,
      hbcu: value.hbcu || 'no',
    };
    this.setState(newState);
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  removeValue = (name) => {
    this.setState({ ...this.state, [name]: undefined });
  };

  addAnotherCollege = () => {
    this.setState({
      addAnotherCollege: true,
      division: '',
      city: '',
      state: '',
      questionLink: '',
      footballConference: '',
      footballDivision: '',
      teamPageUrl: '',
      college: '',
      collegeId: '',
      hbcu: 'no',
      minGpa: '',
      minAct: '',
      twitter: '',
    });
  };

  handleDivisionChange = (hbcu) => {
    this.setState({ hbcu });
  };

  handleOnclick = () => {
    const { minGpa, city, state, division, minAct, college, footballDivision,
           footballConference, teamPageUrl, questionLink, hbcu, twitter } = this.state;
    const payload = {
      college,
      city,
      state,
      division,
      hbcu,
      football_div: footballDivision,
      football_conf: footballConference,
      team_page_link: teamPageUrl,
      question_link: questionLink,
      college_twitter: twitter,
      min_act: parseInt(minAct), // eslint-disable-line
      min_gpa: parseInt(minGpa), // eslint-disable-line
    };
    const checkData = validateData(payload);
    if (checkData.collegeIsValid && checkData.gpaIsValid
       && checkData.actIsValid && checkData.twitterIsValid && checkData.questionLinkIsValid
       && checkData.teamPageLinkIsValid && checkData.divisionIsValid
       && checkData.footballConferenceIsValid
       && checkData.footballDivisionIsValid) {
      this.setState({ addAnotherCollege: false });
      this.props.addCollegeToDB(payload);
    } else {
      this.setState(checkData);
    }
  };

  render() {
    const {
      addAnotherCollege, minGpa, minAct, questionLink, teamPageUrl, footballConference,
      college, city, state, division, hbcu, minGpaErrorMessage, questionLinkErrorMessage,
      teamPageErrorMessage, minActErrorMessage, collegeErrorMessage, stateErrorMessage,
      divisionErrorMessage, cityErrorMessage, footballConferenceErrorMessage,
      footballDivisionErrorMessage, footballDivision, twitter, twitterErrorMessage } = this.state;
    const { collegeAdded } = this.props;
    let form = true;
    if (collegeAdded) {
      form = false;
    }
    if (collegeAdded && addAnotherCollege) {
      form = true;
    }
    const renderForm = renderIf(form);
    const renderSuccessMessage = renderIf(collegeAdded && !addAnotherCollege);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderForm(
          <div className={cn('col s12 m7', styles.addMargin)}>
            <div className={collegeErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>COLLEGE NAME</span>
              <Input
                value={college}
                onChange={val => this.handleChange('college', val)}
                onFocus={() => this.removeValue('collegeErrorMessage')}
              />
              <Error message={collegeErrorMessage} />
            </div>
            <div className={divisionErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>DIVISION</span>
              <AutoComplete
                source={divisions}
                selectedPosition="below"
                direction="down"
                value={division}
                theme={theme}
                multiple={false}
                onChange={val => this.handleChange('division', val)}
                onFocus={() => this.removeValue('divisionErrorMessage')}
              />
              <Error message={divisionErrorMessage} />
            </div>
            <div className={cityErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>CITY</span>
              <Input
                value={city}
                onChange={val => this.handleChange('city', val)}
                onFocus={() => this.removeValue('cityErrorMessage')}
              />
              <Error message={cityErrorMessage} />
            </div>
            <div className={stateErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>STATE</span>
              <AutoComplete
                source={states}
                selectedPosition="below"
                direction="down"
                value={state}
                allowCreate
                multiple={false}
                onChange={val => this.handleChange('state', val)}
                onFocus={() => this.removeValue('stateErrorMessage')}
              />
              <Error message={stateErrorMessage} />
            </div>
            <div className={teamPageErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>TEAMPAGE URL</span>
              <Input
                value={teamPageUrl}
                onChange={val => this.handleChange('teamPageUrl', val)}
                onFocus={() => this.removeValue('teamPageErrorMessage')}
              />
              <Error message={teamPageErrorMessage} />
            </div>
            <div className={questionLinkErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>QUESTIONAIRE URL</span>
              <Input
                value={questionLink}
                onChange={val => this.handleChange('questionLink', val)}
                onFocus={() => this.removeValue('questionLinkErrorMessage')}
              />
              <Error message={questionLinkErrorMessage} />
            </div>
            <div className={footballConferenceErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>FOOTBALL CONFERENCE</span>
              <Input
                value={footballConference}
                onChange={val => this.handleChange('footballConference', val)}
                onFocus={() => this.removeValue('footballConferenceErrorMessage')}
              />
              <Error message={footballConferenceErrorMessage} />
            </div>
            <div className={footballDivisionErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>FOOTBALL DIVISION</span>
              <Input
                value={footballDivision}
                onChange={val => this.handleChange('footballDivision', val)}
                onFocus={() => this.removeValue('footballDivisionErrorMessage')}
              />
              <Error message={footballDivisionErrorMessage} />
            </div>
            <div className={minGpaErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>MINIMUM GPA</span>
              <Input
                value={minGpa}
                onChange={val => this.handleChange('minGpa', val)}
                onFocus={() => this.removeValue('minGpaErrorMessage')}
              />
              <Error message={minGpaErrorMessage} />
            </div>
            <div className={minActErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>MINIMUM ACT</span>
              <Input
                value={minAct}
                onChange={val => this.handleChange('minAct', val)}
                onFocus={() => this.removeValue('minActErrorMessage')}
              />
              <Error message={minActErrorMessage} />
            </div>
            <div className={twitterErrorMessage === undefined ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>TWITTER</span>
              <Input
                value={twitter}
                onChange={val => this.handleChange('twitter', val)}
                onFocus={() => this.removeValue('twitterErrorMessage')}
              />
              <Error message={twitterErrorMessage} />
            </div>
            <div className={cn('col s12 m6', styles.removePadding)}>
              <span className={styles.hbcuSpan}>HBCU</span>
              <RadioGroup name="hbcu" value={hbcu} onChange={this.handleDivisionChange}>
                <RadioButton label="Yes" value="yes" />
                <RadioButton label="No" value="no" />
              </RadioGroup>
            </div>
            <Button label="ADD COLLEGE" onClick={this.handleOnclick} style={styles.buttonContainer} />
          </div>,
        )}
        {renderSuccessMessage(
          <span className={styles.successMessage}>
                 College details are updated. <br /> <br />
            <Button label="MODIFY ANOTHER COLLEGE" onClick={this.addAnotherCollege} style={styles.buttonContainer} />
          </span>,
        )}
      </div>
    );
  }
}

export default AddCollege;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/CollegeView/components/AddCollege/AddCollege.js